import { createRoutine } from 'redux-saga-routines';

export const medicineCabinetGetAllPrescriptions = createRoutine('MEDICINE_CABINET/GET_ALL_PRESCRIPTIONS');
export const medicineCabinetToggleAutoRefillForRx = createRoutine('MEDICINE_CABINET/TOGGLE_AUTOREFILL_FOR_RX');
export const medicineCabinetToggleAutoRefillAllRxs = createRoutine('MEDICINE_CABINET/TOGGLE_ALL_AUTOREFILL_FOR_RX');
export const medicineCabinetGetStatusForRx = createRoutine('MEDICINE_CABINET/GET_STATUS_FOR_RX');
export const medicineCabinetLoadRoutine = createRoutine('MEDICINE_CABINET/LOAD');
